export enum ConversationRole {
  SYSTEM = 'twilio',
  RESIDENT = 'resident',
  VISITOR = 'visitor',
  ADMIN = 'landlord'
}

export enum ReminderCount {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export enum ReminderHours {
  ONE = 1,
  FIVE = 5,
  TWELVE = 12,
  EIGHTEEN = 18
}